import { Alert } from "@mui/material";
import {
  attachmentRequestExceedsLimit,
  attachmentUploadLimitMessage,
} from "../../utils/attachmentUploadLimits";

const AttachmentUploadSizeNotice = ({ files }: { files: File[] }) => {
  const message = attachmentUploadLimitMessage(files);
  if (!message) {
    return null;
  }

  return (
    <Alert
      severity={attachmentRequestExceedsLimit(files) ? "error" : "info"}
      sx={{ mt: 1 }}
    >
      {message}
    </Alert>
  );
};

export default AttachmentUploadSizeNotice;
